exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".section-title[data-v-64f564c6] {\n  padding: 1em;\n}\n.recent-invoices[data-v-64f564c6] {\n  padding-bottom: 2em;\n}\n.recent-invoice[data-v-64f564c6]:not(:last-child) {\n  padding-bottom: 1em;\n  margin-bottom: 1.5em;\n  border-bottom: 1px solid #ebebeb;\n}\n", ""]);

// exports
